import { ActionTypes } from "../../store/actions/newRegistration";

const initialState = {
  user: {
    firstName:'',
    lastName:'',
    type: "",
    email: "",
    password: "",
    phone: "",
  },
  step: 1,
  paymentRedirectLink: "",
};

const defaultState = localStorage.getItem("newRegistration")
  ? {
      ...JSON.parse(localStorage.getItem("newRegistration")),
    }
  : initialState;

function newRegistration(state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.SET_USER_TYPE:
      return {
        ...state,
        user: {
          ...state.user,
          type: action.payload,
        },
        step: 2,
      };

    case ActionTypes.SET_USER_PERSONAL_INFO:
      return {
        ...state,
        user: {
          ...state.user,
          phone: action.payload.phone,
          firstName:action.payload.firstName,
          lastName:action.payload.lastName,
        },
        step: 3,
      };

    case ActionTypes.SET_USER_CREDENTIALS:
      return {
        ...state,
        user: {
          ...state.user,
          email: action.payload.email,
          password: action.payload.password,
        },
        step: 4,
      };

    case ActionTypes.SET_REGISTRATION_STEP:
      return {
        ...state,
        step: action.payload,
      };

    case ActionTypes.SET_TC_AND_PP_TO_NEW_REGISTRATION_DATA:
      return {
        ...state,
        user: {
          ...state.user,
          tc_version: action.payload.tc,
          pp_version: action.payload.pp,
        },
      };

    case ActionTypes.SET_PAYMENT_REDIRECT_LINK:
      return {
        ...state,
        paymentRedirectLink: action.payload,
      };

    case ActionTypes.CLEAR_NEW_REGISTRATION_DATA:
      return initialState;

    default:
      return state;
  }
}

export default newRegistration;



// WEBPACK FOOTER //
// ./src/js/store/reducers/newRegistration.js